import { ReactNode } from "react";
import CenteredArea from "./centered-area";
import StatusText from "./status-text";
type LoadingFallbackProps = {
  children?: ReactNode;
};
export default function LoadingFallback({
  children
}: LoadingFallbackProps) {
  return <CenteredArea data-sentry-element="CenteredArea" data-sentry-component="LoadingFallback" data-sentry-source-file="loading-fallback.tsx">
      <StatusText variant="loading" data-sentry-element="StatusText" data-sentry-source-file="loading-fallback.tsx">{children ? children : "Loading..."}</StatusText>
    </CenteredArea>;
}